import { useContext } from 'react';
import { AppContext } from '../sporttia/AppContext';
import {
    PermissionCode,
    PermissionRequirement,
    can as canAccess,
    canAny as canAnyAccess,
} from './permissions';

/**
 * Permisos v8 del operador conectado, leídos de `AppContext`.
 *
 * - `can(code | codes[])`: con los roles apagados siempre `true`; con un código
 *   lo exige y con una lista exige todos.
 * - `canAny(codes[])`: basta con uno de la lista.
 */
export function usePermission() {
    const cxt = useContext(AppContext)!;
    const access = {
        permissions: cxt.permissions,
        rolesEnabled: cxt.rolesEnabled,
    };

    return {
        can: (required: PermissionRequirement) => canAccess(access, required),
        canAny: (required: readonly PermissionCode[]) =>
            canAnyAccess(access, required),
        rolesEnabled: access.rolesEnabled,
        permissions: access.permissions,
    };
}
